import BigClientLang from '@/modules/institutional-client/InstitutionalClientPage.lang';
import {LINKS, PATHS} from '@/const';
import lang from './Footer.lang';

export const aaa = () => 21312312312312;

export const GetFooterLinks = (language, isLogin, isSupportMarginTrading, fiatABTest, VIPProgramPageLink, isMobile) => {
  const buyCryptoLink = isLogin ? (fiatABTest ? PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname : PATHS.BUY_CRYPTO_PLACE_ORDER.pathname) : PATHS.BUY_CRYPTO.pathname;
  return [
    {
      title: lang.Products,
      order: 0,
      children: [
        {
          label: lang.Contract,
          link: LINKS.PHEMEX_CONTRACT_INVERSE_TRADE,
          linkTag: 'TRADE',
          belong: 'LINKS',
          gal: 'contract',
        },
        {
          label: lang.Spot,
          link: LINKS.SPOT_TRADE,
          linkTag: 'TRADE',
          belong: 'LINKS',
          gal: 'spot',
        },
        isSupportMarginTrading
          ? {
              label: lang.MarginTrading,
              link: LINKS.PHEMEX_SPOT_MARGIN_TRADE,
              linkTag: 'TRADE',
              belong: 'LINKS',
              gal: 'margin trading',
            }
          : {},
        {
          label: lang.BuyCrypto,
          link: buyCryptoLink,
          belong: 'PATHS',
          gal: 'buy_crypto',
        },
        {
          label: lang.CryptoConverter,
          link: PATHS.CRYPTO_CONVERTER.pathname,
          belong: 'PATHS',
          gal: 'CryptoConverter',
        },
        {
          label: lang.EarnCrypto,
          link: PATHS.EARN_HOME.pathname,
          belong: 'PATHS',
          gal: 'earn_crypto',
        },
        {
          label: lang.Launchpool,
          link: PATHS.LAUNCHPOOL.pathname,
          belong: 'PATHS',
          gal: 'Launchpool',
        },
        {
          label: lang.TradingBots,
          link: PATHS.STRATEGY_SQUARE.pathname,
          belong: 'PATHS',
          gal: 'trading_bots',
        },
      ],
    },
    {
      title: lang.Support,
      order: isMobile ? 1 : 0,
      children: [
        {
          label: lang.HelpCenter,
          link: LINKS.PHEMEX_HELP_CENTER,
          linkTag: 'CMS',
          belong: 'LINKS',
          gal: 'help_center',
          target: '_blank',
        },
        {
          label: lang.Academy,
          link: LINKS.PHEMEX_ACADEMY,
          linkTag: 'CMS',
          belong: 'LINKS',
          gal: 'spot_guides',
          target: '_blank',
        },
        {
          label: lang.LearnAndEarn,
          link: PATHS.LEARN_CRYPTO.pathname,
          belong: 'PATHS',
          gal: 'LearnAndEarn',
          target: '_blank',
        },
        {
          label: lang.CryptoBlog,
          link: LINKS.PHEMEX_BLOG,
          linkTag: 'CMS',
          belong: 'LINKS',
          gal: 'CryptoBlog',
          target: '_blank',
        },
        {
          label: lang.FeesConditions,
          link: PATHS.FEES_CONDITIONS.pathname,
          belong: 'PATHS',
          gal: 'fee_conditions',
        },
        {
          label: lang.PhemexAPI,
          link: PATHS.APIS.pathname,
          belong: 'PATHS',
          gal: 'api_doc',
          target: '_blank',
        },
        {
          label: lang.ContractReferences,
          link: PATHS.CONTRACT_INTRODUCTION.pathname,
          belong: 'PATHS',
          gal: 'contract_references',
        },
        {
          label: lang.OfficialVerification,
          link: PATHS.OFFICIAL_VERIFICATION.pathname,
          belong: 'PATHS',
          gal: 'official-verification',
        },
        {
          label: lang.Feedback,
          link: LINKS.FEEDBACK,
          belong: 'LINKS',
          gal: 'feedback',
          target: '_blank',
        },
      ],
    },
    {
      title: lang.Services,
      order: isMobile ? 2 : 1,
      children: [
        {
          label: lang.WelcomeBonus,
          link: PATHS.BONUS.pathname,
          belong: 'PATHS',
          gal: 'welcome_bonus',
        },
        {
          label: lang.Referral,
          link: PATHS.ACCOUNT_INVITE_FRIENDS.pathname,
          belong: 'PATHS',
          gal: 'referral_invite_friends',
        },
        {
          label: lang.Portal,
          link: PATHS.VIP_PORTAL.pathname,
          belong: 'PATHS',
          gal: 'vip_portal',
        },
        {
          label: lang.VIPProgram,
          link: VIPProgramPageLink,
          belong: 'CUSTOM',
          gal: 'vip_program',
        },
        {
          label: lang.AllStarProgram,
          link: PATHS.ALL_STAR_PROGRAM.pathname,
          belong: 'PATHS',
          gal: 'all_star_program',
        },
        {
          label: BigClientLang.InstitutionClientProgram,
          link: PATHS.INSTITUTIONAL_CLIENT.pathname,
          belong: 'PATHS',
          gal: 'institutional_clients',
        },
        {
          label: BigClientLang.ListingApplication,
          link: language === 'de' ? LINKS.LISTING_APPLICATION_DE : LINKS.LISTING_APPLICATION,
          linkTag: 'CMS',
          belong: 'LINKS',
        },
        {
          label: BigClientLang.ListingSuggestions,
          link: language === 'de' ? LINKS.LISTING_SUGGESTIONS_DE : LINKS.LISTING_SUGGESTIONS,
          linkTag: 'CMS',
          belong: 'LINKS',
        },
        {
          label: lang.SimulatedTrading,
          link: LINKS.PHEMEX_TESTNET,
          belong: 'LINKS',
        },
      ],
    },
    {
      title: lang.Partners,
      order: isMobile ? 3 : 2,
      children: [
        {
          label: lang.CoinMarketCap,
          link: LINKS.COINMARKETCAP_LINK,
          belong: 'LINKS',
          gal: 'coinmarketcap',
          target: '_blank',
        },
        {
          label: lang.CoinGecko,
          link: LINKS.COINGECKO_LINK,
          belong: 'LINKS',
          gal: 'coingecko',
          target: '_blank',
        },
        {
          label: lang.Coincodex,
          link: LINKS.COINCODEX_LINK,
          belong: 'LINKS',
          gal: 'coincodex',
          target: '_blank',
        },
        {
          label: lang.TradingView,
          link: LINKS.TRADINGVIEW_LINK,
          belong: 'LINKS',
          gal: 'tradingview',
          target: '_blank',
        },
      ],
    },
    {
      title: lang.BuyMoreCryptos,
      order: isMobile ? 4 : 2,
      children: [
        {
          label: lang.BuyBitcoinBtn,
          link: PATHS.BUY_CRYPTO_BUY_BTC.pathname,
          belong: 'PATHS',
          gal: 'buy_bitcoin_btn',
          target: '_blank',
        },
        {
          label: lang.BuyDogecoin,
          link: PATHS.BUY_CRYPTO_BUY_DOGE.pathname,
          belong: 'PATHS',
          gal: 'buy_dogecoin',
          target: '_blank',
        },
        {
          label: lang.BuyLitecoin,
          link: PATHS.BUY_CRYPTO_BUY_LTC.pathname,
          belong: 'PATHS',
          gal: 'buy_litecoin',
          target: '_blank',
        },
        {
          label: lang.BuyEthereumBtn,
          link: PATHS.BUY_CRYPTO_BUY_ETHEREUM.pathname,
          belong: 'PATHS',
          gal: 'buy_ethereum_btn',
          target: '_blank',
        },
      ],
    },
    {
      title: lang.Company,
      order: isMobile ? 5 : 3,
      children: [
        {
          label: lang.AboutUs,
          link: PATHS.ABOUT.pathname,
          belong: 'PATHS',
          gal: 'about_us',
        },
        {
          label: lang.Brandsite,
          link: PATHS.ABOUT_BRAND_STYLE_GUIDE.pathname,
          belong: 'PATHS',
          gal: 'brandsite',
        },
        {
          label: lang.Careers,
          link: LINKS.PHEMEX_JOBS,
          belong: 'LINKS',
          gal: 'careers',
          target: '_blank',
        },
        {
          label: lang.StudentFoundation,
          link: PATHS.STUDENT_FOUNDATION.pathname,
          belong: 'PATHS',
          gal: 'student',
        },
        {
          label: lang.Announcements,
          link: LINKS.PHEMEX_REFERENCES_ANNOUNCEMENTS,
          linkTag: 'CMS',
          belong: 'LINKS',
          gal: 'announcements',
          target: '_blank',
        },
        {
          label: lang.Security,
          link: PATHS.SECURITY.pathname,
          belong: 'PATHS',
          gal: 'security',
        },
        {
          label: lang.PrivacyPolicy,
          link: LINKS.PHEMEX_REFERENCES_PRIVACY_POLICY,
          linkTag: 'CMS',
          belong: 'LINKS',
          gal: 'privacy_policy',
          target: '_blank',
        },
        {
          label: lang.TermsUse,
          link: LINKS.PHEMEX_REFERENCES_TERMS_OF_USE,
          linkTag: 'CMS',
          belong: 'LINKS',
          gal: 'terms',
          target: '_blank',
        },
        {
          label: lang.SiteMap,
          link: PATHS.SITEMAP.pathname,
          belong: 'PATHS',
          gal: 'sitemap',
        },
      ],
    },
  ];
};
